import React from "react";
import { HomeManageSelectedItemsTemplate } from "themes/application/home/components";

function HomeManageSelectedItems(props) {
    return <HomeManageSelectedItemsTemplate {...props} />;
}

export default HomeManageSelectedItems;